// extracted by mini-css-extract-plugin
export default {"tabs":"MessagingDrawer_tabs__ls0Fc","tab":"MessagingDrawer_tab__v+Jjj","drawerContainer":"MessagingDrawer_drawerContainer__XjodE"};